<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width="400" content-class="round-2xl")
  v-card
    div.px-6.pt-6.pb-0
      div.text-xl.font-bold.danger500--text Editing Not Allowed
      div.text-lg.mt-3.neutral700--text You do not have the permission to edit this document.
    v-card-actions.px-6.pt-0.pb-6
      v-spacer
      y-button(label="Close" size="md" dark button-class="px-0" @click="closeDialog")
</template>

<script>

export default {
  props: {
    open: {
      type: Boolean,
    },
    loading: {
      type: Boolean
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    }
  },
}
</script>